import styled from 'styled-components'
import { useState } from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'
import { TransparentButton } from 'common/button'
import { IoMdAlert } from 'react-icons/io'
import PointsModal from './points-modal'

const sections = [
  {
    title: 'Este mes',
    id: 'monthly',
  },
  {
    title: 'Esta semana',
    id: 'weekly',
  },
  {
    title: 'Este año',
    id: 'yearly',
  },
  {
    title: 'Todos',
    id: 'all',
  },
]


const PodiumFilterStyled = styled.div`
  display: flex;
  justify-content: space-between;
  margin-block-end: 24px;
  flex-wrap: wrap;
  .sections {
    display: grid;
    grid-template-columns: repeat(4, max-content);
    overflow: auto;
  }
  .section {
    padding: 8px 12px;
    font-weight: bold;
    color: var(--neutral40);
    display: block;
  }
  .active {
    border-bottom: 4px solid var(--secondary);
    color: var(--baseSecondary);
  }
  button {
    margin-block-start: 16px;
    font: var(--regularBold);
    svg {
      margin-left: 8px;
    }
  }
  @media(min-width: 768px) {
    button {
      margin-block-start: 16px;
    }
  }
`

function PodiumFilter() {
  const { query: { period } } = useRouter()
  const [points, setPoints] = useState(false)
  const param = period || 'monthly'
  return (
    <PodiumFilterStyled>
      <ul className="sections">
        {sections.map(({ title, id }) => {
          return (
            <li key={title} className={param === id ? 'active section' : 'section'}>
              <Link href={`/podium?period=${id}`} shallow>
                {title}
              </Link>
            </li>
          )
        })}
      </ul>
      <TransparentButton color="var(--turquoise)" onClick={() => setPoints(true)}>
        ¿Cómo ganar puntos?
        <IoMdAlert size={20} />
      </TransparentButton>
      <PointsModal points={points} setPoints={setPoints} />
    </PodiumFilterStyled>
  )
}

export default PodiumFilter
